<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow" v-loading.fullscreen.lock="pageData.allLoading"
        :element-loading-text="$t('App.page.login.loadingviadingtalk')" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="head_wrap">
          <div class="language_wrap">
            <el-dropdown placement="bottom" :show-timeout="100" @command="setLanguage">
              <div style="color: #409eff">
                <i class="fa fa-globe fa-2x"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="en">English</el-dropdown-item>
                <el-dropdown-item command="cn">Chinese(Simplified)</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="body_wrap">
          <div class="image_wrap"></div>
          <div class="login_wrap">
            <el-form ref="form_login" :model="formData.login" class="form_login" :rules="rule_login">
              <div class="login_img">
                <el-image :src="pageData.loginlogoSrc">
                  <div slot="placeholder" class="image-slot">
                    {{ $t('App.text.loading') }}
                  </div>
                </el-image>
              </div>
              <div class="login_inputs">
                <el-form-item prop="username">
                  <el-input name="username" autocomplete="on" :placeholder="this.$t('App.text.phd_username')"
                    v-model="formData.login.username" clearable maxlength="15" show-word-limit prefix-icon="fa fa-user"
                    autofocus size="small">
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input :placeholder="this.$t('App.text.phd_password')" v-model="formData.login.password"
                    show-password clearable maxlength="15" show-word-limit prefix-icon="fa fa-lock"
                    @keypress.native.enter="doSubmit('form_login')" size="small"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button size="mini" type="success" @click="doSubmit('form_login')" :loading="pageData.subLoad">{{
                    $t('App.text.dologin') }}</el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <div class="foot_wrap"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as utilsjs from '@/assets/js/utils'
import Vue from 'vue'
import DragVerify from 'vue-drag-verify'
export default {
  components: {
    DragVerify,
  },
  data() {
    return {
      pageData: {
        subLoad: false,
        allLoading: false,
        loginlogoSrc: require('@/assets/images/logo.png'),
        custUserinfo: {},
      },
      verify: {
        handlerIcon: 'fa fa-angle-double-right',
        successIcon: 'fa fa-check',
        background: '#DCDFE6',
        progressBarBg: '#4b0',
        completedBg: '#67C23A',
        handlerBg: '#fff',
        width: 320,
        height: 50,
        textSize: '1',
      },
      shown: {
        mainshow: false,
      },
      formData: {
        login: {
          username: '',
          password: '',
        },
      },
      rule_login: {
        username: [
          {
            required: true,
            message: this.$t('App.verify.username_required'),
            trigger: 'blur',
          },
          {
            min: 2,
            max: 15,
            message: this.$t('App.verify.username_length'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('App.verify.password_required'),
            trigger: 'blur',
          },
          {
            min: 3,
            max: 15,
            message: this.$t('App.verify.password_length'),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    document.title = this.$t('App.title.login')
    this.$i18n.locale = sessionStorage.getItem('lang')
    sessionStorage.setItem('lang', this.$i18n.locale)
    setTimeout(() => {
      this.shown.mainshow = true
    }, 1)

    let agent = navigator.userAgent
    if (
      agent.indexOf('Opera') > -1 ||
      agent.indexOf('Firefox') > -1 ||
      agent.indexOf('Chrome') > -1 ||
      agent.indexOf('Safari') > -1 ||
      agent.indexOf('Trident') > -1
    ) {
    } else {
      this.$alert(this.$t('App.text.login_alert'), {
        confirmButtonText: this.$t('App.text.ikonw'),
        type: 'success',
      })
    }
    utilsjs.requestDingAuthCode(this).then((authCode) => {
      if (authCode != null) {
        this.pageData.allLoading = true
        this.loginViaDingtalk(authCode)
      } else {
      }
    })
  },
  methods: {
    setLanguage(command) {
      this.$i18n.locale = command
      sessionStorage.setItem('lang', this.$i18n.locale)
    },
    doSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$npg.start()
          this.$npg.inc()
          this.pageData.subLoad = true
          // console.log(Vue.prototype.api + '6001/api/local/doLogin',Vue.prototype.api2)
          console.log(
            Vue.prototype.api + 'api/local/doLogin',
            Vue.prototype.api2,
          )
          this.$axios({
            method: 'post',
            // url: Vue.prototype.api + '6001/api/local/doLogin',
            url: Vue.prototype.api + 'api/local/doLogin',
            data: this.formData.login,
          })
            .then((response) => {
              if (response.status == 200) {
                if (
                  response.data.code == '200' &&
                  response.data.data.username == this.formData.login.username
                ) {
                  this.$npg.done()
                  this.pageData.custUserinfo.way = 0
                  this.setUserInfo(response)

                  setTimeout(() => {
                    if (response.data.data.user.usertype.type == '1') {
                      console.log('返回首页')
                      this.$router.push({ name: 'Home' })
                    } else {
                      console.log('返回登录页')

                      this.$router.push({ path: '/console/' })
                    }
                  }, 1)
                } else if (response.data.code == '600') {
                  this.$npg.done()
                  this.pageData.subLoad = false
                  this.$notify.error({
                    title: this.$t('App.notify.title_warning'),
                    message: this.$t('App.notify.content_illegal'),
                  })
                  return
                } else if (response.data.code == '700') {
                  if (response.data.message != undefined) {
                    this.$npg.done()
                    this.pageData.subLoad = false
                    this.$notify.error({
                      title: this.$t('App.notify.title_err'),
                      message: this.$t('App.notify.content_user_disabled'),
                    })
                    return
                  }
                  this.$npg.done()
                  this.pageData.subLoad = false
                  this.$notify.error({
                    title: this.$t('App.notify.title_err'),
                    message: this.$t('App.notify.content_unknownerr'),
                  })
                  return
                } else {
                  this.$npg.done()
                  this.pageData.subLoad = false
                  this.$notify.error({
                    title: this.$t('App.notify.title_retry'),
                    message: this.$t('App.notify.content_loginerr'),
                  })
                  return
                }
              } else {
                this.$npg.done()
                this.pageData.subLoad = false
                this.$notify.error({
                  title: this.$t('App.notify.title_server'),
                  message:
                    this.$t('App.notify.content_server') + response.status,
                })
                return
              }
            })
            .catch((error) => {
              console.log('error', error)
              this.$npg.done()
              this.pageData.subLoad = false
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            })
        } else {
          return false
        }
      })
    },
    loginViaDingtalk(authCode) {
      let dingtalkLoginRequest = {}
      dingtalkLoginRequest.code = authCode
      dingtalkLoginRequest.index = process.env.DINGTALK_TOKEN_INDEX
      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6001/api/local/loginViaDingtalk',
        url: Vue.prototype.api + 'api/local/loginViaDingtalk',
        data: dingtalkLoginRequest,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              this.pageData.allLoading = false
              this.pageData.custUserinfo.way = 1
              this.setUserInfo(response)
              setTimeout(() => {
                if (response.data.data.user.usertype.type == '1') {
                  this.$notify.error({
                    title: this.$t('App.notify.title_err'),
                    message: this.$t('App.notify.content_unknownerr'),
                  })
                  return
                } else {
                  this.$router.push({ path: '/console/analysis' })
                }
              }, 1)
            } else if (response.data.code == '210') {
              this.pageData.allLoading = false
              this.$notify.warning({
                title: this.$t('App.notify.title_nofity'),
                message: this.$t('App.page.login.notify_dingtalk_not_bound'),
                duration: 0,
              })
              return
            } else if (response.data.code == '404') {
              this.pageData.allLoading = false
              this.$notify.error({
                title: this.$t('App.notify.title_err'),
                message:
                  this.$t('App.notify.content_unknownerr') + 'OUT_OF_DATE',
                duration: 0,
              })
              return
            } else {
              this.pageData.allLoading = false
              this.$notify.error({
                title: this.$t('App.notify.title_err'),
                message: this.$t('App.notify.content_unknownerr'),
              })
              return
            }
          } else {
            this.pageData.allLoading = false
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          this.pageData.allLoading = false
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    setUserInfo(response) {
      // if (response.data.data.brand_list === 1) {
      //   sessionStorage.setItem('brand_title', 'Silent Power')
      // } else if (response.data.data.brand_list === 0) {
      //   sessionStorage.setItem('brand_title', 'iFi Audio')
      // } else {
      //   sessionStorage.setItem('brand_title', 'iFi Audio&Silent Power')
      // }
      sessionStorage.setItem('brand_title', response.data.data.customerBrandEntityList ? response.data.data.customerBrandEntityList.map(item => item.brandName).join('&') : '')
      sessionStorage.setItem('username', response.data.data.username)

      //原代码
      // this.pageData.custUserinfo.username = response.data.data.username
      // this.pageData.custUserinfo.name = response.data.data.name
      // this.pageData.custUserinfo.brand_list = response.data.data.brand_list
      // this.pageData.custUserinfo.country = response.data.data.country
      // this.pageData.custUserinfo.discount = response.data.data.discount
      // this.pageData.custUserinfo.minweight = response.data.data.min_weight
      // this.pageData.custUserinfo.minamount = response.data.data.min_amount
      // this.pageData.custUserinfo.region = response.data.data.region
      // this.pageData.custUserinfo.currency = response.data.data.currency
      //  this.pageData.custUserinfo.usertype =response.data.data.user.usertype.type
      // this.pageData.custUserinfo.paymentterms = response.data.data.paymentterms
      // this.pageData.custUserinfo.k3id = response.data.data.k3id
      // this.pageData.custUserinfo.k3pass = response.data.data.k3pass
      // this.pageData.custUserinfo.k3FSalerId = response.data.data.k3FSalerId
      // this.pageData.custUserinfo.k3FCustId = response.data.data.k3FCustId
      // this.pageData.custUserinfo.feedback = response.data.data.feedback
      this.pageData.custUserinfo = response.data.data
      this.pageData.custUserinfo.usertype =
        response.data.data.user.usertype.type
      this.pageData.custUserinfo.minweight = response.data.data.min_weight
      this.pageData.custUserinfo.minamount = response.data.data.min_amount
      sessionStorage.setItem(
        response.data.data.username,
        JSON.stringify(this.pageData.custUserinfo),
      )
    },
  },
}
</script>

<style scoped>
.head_wrap {
  /* height: 3rem; */
  display: flex;
}

.language_wrap {
  /* text-align: end; */
  /* padding: 1rem; */
  right: 1rem;
  top: 1rem;
  position: fixed;
}

/* .main_wrap {
  width: 100vh;
  height: 100vh;
} */
.body_wrap {
  width: 100%;
  height: 100vh;
  display: table;
}

.image_wrap {
  width: 100%;
  background-image: url(../../assets/images/alt2.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  user-select: none;
}

.image_wrap,
.login_wrap {
  display: table-cell;
}

/* .login_wrap {
  width: 100%;
  height: 100%;
  margin-top: 10rem;
} */
.login_wrap {
  margin-top: 18rem;
  margin-right: 5rem;
  margin-left: 5rem;
  float: right;
}

.login_wrap .el-image {
  width: 4.5rem;
  /* height: 5rem; */
  margin-bottom: 2rem;
}

.login_inputs .el-input,
.login_inputs .el-button {
  width: 20rem;
}

/* .login_inputs .el-input {
  font-size: 0.9rem;
} */
.login_inputs .el-button {
  font-size: 1rem;
}

.login_drag {
  margin: 0 auto;
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/views/common/Login.vue